import Navigation from "../../components/components/Navigation";
import BizPricing from "../../components/components/BizPricing";
import Footer from "../../components/Common/Footer";

const PricingPage = () => {
  return (
    <>
      <Navigation type="biz" page="normal" />
      <div>
        <BizPricing />
        <Footer type="biz" />
      </div>
    </>
  );
};

export default PricingPage;
